import { nanoid } from 'nanoid'
import Interaction from './interaction'
import TextModel from './textModel'

/**
 * Items to be displayed within an action menu component
 */
export default class MenuItem {
  constructor({
    id = nanoid(),
    text = '',
    subtitle = '',
    type = '',
    icon = '',
    interaction = new Interaction(),
    rules = [],
    attributes = {},
    data = {},
  } = {}) {
    /**
     * @type {String}
     */
    this.id = id

    /**
     * Text to be displayed on the menu item
     * @type {String}
     */
    this.text = text

    /**
     * Text to be displayed under the menu item text
     * @type {String|TextModel}
     */
    this.subtitle = subtitle

    /**
     * Type of the menu item to define its purpose. E.g. divider (non-actionable)
     * @type {String}
     */
    this.type = type

    /**
     * Material design icon. E.g. mdi-account
     * @type {String?}
     */
    this.icon = icon

    /**
     * Describes what will happen when the menu item is clicked
     * @type {Interaction}
     */
    this.interaction = interaction

    /**
     * An array of boolean values, all must be true to show menu item
     * @type {Array}
     */
    this.rules = rules

    /**
     * Object containing attributes to style the menu item
     * @type {Object}
     * @see https://v2.vuetifyjs.com/en/api/v-btn/ for full list of attributes
     * @example
     *
     * ```
     * {
     *    id: 'confirm-btn',
     *    color: VuetifyColourClass.primary,
     *    text: true,
     *    title: 'Click here to accept the terms',
     *    'data-testid': 'promise-dialog--confirm-btn'
     * }
     * ```
     */
    this.attributes = attributes

    /**
     * Contains any miscellaneous relevant data to the menuItem.
     * Helpful for the disable comparison function in the base dropdown component.
     * @type {Object}
     * @example
     *
     * ```
     * {
     *    disabled: true,
     *    bookingId: 123456
     * }
     * ```
     */
    this.data = data
  }

  /**
   * Check if the subtitle is an instance of TextModel.
   * @returns {boolean} True if subtitle is an instance of TextModel, otherwise false.
   */
  isSubtitleTextModel() {
    return this.subtitle instanceof TextModel
  }

  getSubtitleText() {
    return this.isSubtitleTextModel() ? this.subtitle?.text : this.subtitle
  }

  getSubtitleCSSClasses() {
    return this.isSubtitleTextModel() ? this.subtitle.getClasses() : ''
  }
}
